import AuthFooter from "components/Footers/AuthFooter";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import React from 'react';

const TermsAndConditions = () => {
    return (
        <>
            <IndexNavbar />
            <div
                className="container"
                style={{
                    fontFamily: "Raleway sans-serif !important",
                    textAlign: "justify",
                    fontSize: "medium"
                }}
            >
                <section
                    className="mb-0 pt-10"
                    id="about"
                    style={{
                        marginBottom: "20px !important",
                        fontFamily: "Raleway sans-serif",
                        marginTop: 50
                    }}
                >
                    <div className="container" id="term">
                        <div className="mb-5 text-center">
                            <h3 className="fs-xl-10 fs-lg-8 fs-7 fw-bold text-capitalize">
                                TERMS OF USE
                            </h3>
                        </div>
                        <div className="row">
                            <h3>1. INTRODUCTION</h3>
                            <p>
                                Please read these Terms and Conditions
                                carefully before using the aloPay mobile application (the "Service")
                                operated by us.
                                <br />


                                Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms.
                                These Terms apply to all visitors, users, and others who access or use the Service.

                                <br />

                                <p>
                                    By accessing or using the Service, you agree to be bound by these Terms.
                                    If you disagree with any part of the terms, then you may not access the Service.
                                </p>
                            </p>
                            <h4> 2. USE OF SERVICE </h4>
                            <ol className="list-decimal list-inside space-y-2">
                                <li>The Service is designed for business management purposes, including customer and product management, invoice and receipt generation, and payment processing.</li>
                                <li>You are responsible for maintaining the confidentiality of your account and password and for restricting access to your account. You agree to accept responsibility for all activities that occur under your account or password.</li>
                            </ol>

                            <br />
                            <br />
                            <h4>
                                3. CONTENT
                            </h4>

                            <ul>

                                <li>Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, or other material ("Content"). You are responsible for the Content that you post on or through the Service, including its legality, reliability, and appropriateness.</li>
                                <li>By posting Content on or through the Service, you represent and warrant that:<br /> (i) the Content is yours (you own it) or you have the right to use it and grant us the rights and license as provided in these Terms, and <br />(ii) the posting of your Content on or through the Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person.</li>

                            </ul>
                            <h5>
                                4. ACCOUNTS
                            </h5>
                            <p>
                                When you create an account with us, you must provide information that is accurate, complete, and current at all times.
                                Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.
                            </p>
                            <br />
                            <br />
                            <h5>5. INTELLECTUAL PROPERTY</h5>
                            <p>
                                The Service and its original content (excluding Content provided by users), features, and functionality are and will remain the exclusive property of aloPay and its licensors.
                                The Service is protected by copyright, trademark, and other laws of both the Ghana and foreign countries.
                                Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of aloPay.
                            </p>
                            <br />
                            <br />
                            <h4>6. LINKS TO OTHER WEBSITES</h4>
                            <ol className="list-decimal list-inside space-y-2">
                                <li>Our Service may contain links to third-party websites or services that are not owned or controlled by aloPay.</li>
                                <li>aloPay has no control over and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
                                    You further acknowledge and agree that aloPay shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.</li>
                            </ol>
                            <br />
                            <br />
                            <h4>7.TERMINATION</h4>
                            <ol className="list-decimal list-inside space-y-2">
                                <li>We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</li>
                                <li>Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.</li>
                            </ol>
                            <h4>8. LIMITATION OF LIABILITY</h4>
                            <p>
                                In no event shall aloPay, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.
                            </p>
                            <br />
                            <br />
                            <h4>9. DISCLAIMER</h4>
                            <p>
                                Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis.
                                The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.
                            </p>
                            <br />
                            <br />
                            <h4>10. GOVERNING LAW</h4>
                            <p>
                                These Terms shall be governed and construed in accordance with the laws of Ghana, without regard to its conflict of law provisions.
                                These Terms shall be governed and construed in accordance with the laws of Ghana, without regard to its conflict of law provisions.
                            </p>
                            <br />
                            <br />
                            <h4>11. CHANGES</h4>
                            <br />
                            <p>
                                We reserve the right, at our sole discretion, to modify or replace these Terms at any time.
                                If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect.
                                What constitutes a material change will be determined at our sole discretion.
                            </p>
                            <br />

                            <h4>12. CONTACT US</h4>
                            <br />
                            <p>
                            If you have any questions about these Terms, please contact us at +233 551 611 100.
                            By using the Service, you agree to these Terms and Conditions.
                                What constitutes a material change will be determined at our sole discretion.
                            </p>
                            <br />
                            <br />
                           

                        </div>
                    </div>
                </section>
            </div>
            <AuthFooter />
        </>
    );
};


export default TermsAndConditions;